import * as React from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Link from 'next/link'

interface ListItemData {
    id: string
    name: string;
    description: string;
    href: string;
    icon: React.ForwardRefExoticComponent<Omit<React.SVGProps<SVGSVGElement>, "ref"> & {
        title?: string | undefined;
        titleId?: string | undefined;
    }>;
    newWindow: boolean;
  }
  
  interface BasicListProps {
    items: ListItemData[];
  }

  export default function BasicList({ items }: BasicListProps) {
    return (
      <Box sx={{ width: '100%', maxWidth: '100%', bgcolor: 'background.paper' }}>
        <nav aria-label="main mailbox folders">
          <List>
          <div className="p-4">
          {items.map((item) => {
            const isNewWindow = item.newWindow || false;

            return (
              <div
                key={item.name}
                className="group relative flex items-center gap-x-6 rounded-lg p-4 text-sm leading-6 hover:bg-gray-50"
              >
                <div className="flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                  <item.icon className="h-6 w-6 text-gray-600 group-hover:text-indigo-600" aria-hidden="true" />
                </div>
                <div className="flex-auto">
                  {isNewWindow ? (
                    <a href={item.href} className="block font-semibold text-gray-900" target="_blank" rel="noopener noreferrer">
                      {item.name}
                      <span className="absolute inset-0" />
                    </a>
                  ) : (
                    <Link href={item.href} className="block font-semibold text-gray-900">
                      {item.name}
                      <span className="absolute inset-0" />
                    </Link>
                  )}
                  <div className="mt-1 text-gray-600">{item.description}</div>
                </div>
              </div>
            );
          })}
        </div> 
          </List>
        </nav>
      </Box>
    );
  }

